module.exports = __webpack_public_path__ + "static/media/Calamaresfritos.343ea4bc.jpg";